import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Alert, Grid } from "@mui/material";
import { FormTextField, HeaderDivider } from "components";
import { CandidateDetailsFormData } from "../validation";

export const ContactDetails = ({
  control,
  age,
}: {
  control: Control<CandidateDetailsFormData>;
  age?: number;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderDivider text={t("details.contactInfoTitle")} sx={{ mb: 3 }} />
      <Grid container spacing={2} sx={{ mb: 8 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormTextField
            name="emailAddress"
            label={t("details.email.label")}
            placeholder={t("details.email.placeholder")}
            control={control}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormTextField
            name="confirmEmailAddress"
            label={t("details.confirmEmail.label")}
            placeholder={t("details.confirmEmail.placeholder")}
            control={control}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormTextField
            name="phoneNumber"
            label={t("details.phone.label")}
            placeholder={t("details.phone.placeholder")}
            control={control}
            type="phone"
            required
          />
        </Grid>
        {age !== undefined && age < 18 && (
          <>
            <Grid size={{ xs: 12, md: 6 }}>
              <FormTextField
                name="guardian"
                label={t("details.guardian.label") + "**"}
                placeholder={t("details.guardian.placeholder")}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Alert severity="info">** {t("details.guardian.hintText")}</Alert>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};
